<template>
	<main class="layout-default h-100">
		<slot />
	</main>
</template>
